<template lang="pug">
validation-observer.analise(ref='validation' tag='div', v-if="dadosCadastros")
  div(v-if="hasAnaliseAutomatizada")
    analise-automatizada(
      :protocoloProcesso="processo.numeroProtocolo",
      :analiseSalva="dadosCadastros.despacho.analiseAutomatizada"
      :idDespacho="dadosCadastros.despacho.id"
      @cancelar="cancelar",
      @changeAnalise="changeAnalise"
      @retornarCaixa="retornarCaixa"
      @finalizar="finalizarAutomatizada"
      @salvar="salvarAutomatizada"
      :radios="acoesRadio"
      :isDecisao="isDecisao",
      :active="active"
      :tipoProcesso="processo.tipo.codigo",
      @changeRadio="changeRadio"
      @setActive="setActivePai"
    )
      template(slot="anexoMapas")
        div(v-if="(processo.status === 'EM_ANALISE' || processo.status === 'EM_REVISAO')")
          app-label.campo(
            label="Mapas"
            :required="isValidate !== ''"
          )
          validation-provider(:rules="isValidate", v-slot="{ errors }")
            app-anexo(
              :id="'upload-anexo-mapa-gcg-automatizada'",
              @uploadFile="uploadMapa",
              :tiposArquivosPermitidos="'.png, .jpg, .jpeg, .pdf, .doc, .docx'",
              :files="mapas",
              @removeFile="removeMapa",
              :showAnexar="true"
              :errors="errors"
              @downloadDocumentoCadastro="getDownload",
              v-model="mapas"
            )

  div(v-else)
    app-modal-beneficiario(
      :protocoloProcesso="processo.numeroProtocolo",
      :beneficiarios="dadosCadastro.dadosCadastro.dados.cadastro.beneficiarios"
      :cadastroOriginal="dadosCadastro.dadosCadastro.dados.cadastro"
      v-if="showModalBeneficiarios"
      @closeModal="showModalBeneficiarios = false"
      @updateBeneficiarios="updateBeneficiarios"
    )
    app-modal-selecionar-modelo-notificacao(
      :tiposModelo="tiposModelo",
      :titulo="tituloModalModelo",
      :idProcesso="processo.id"
      v-if="showModalDespacho",
      :showModal="showModalDespacho"
      @closeModal="fecharModalDespacho",
      @setTextoDespacho="setTextoDespacho"
    )
    el-card(shadow='hover').card-collapse
      app-header-dados-processo(
        :processo="processo",
        :isCCR="isCCR",
        :dadosCadastros="dadosCadastros",
        :numeroTituloDominial="numeroTituloDominial"
        :numeroProcessoFisico="numeroProcessoFisico"
        :dataEmissaoTituloDominial="dataEmissaoTituloDominial"
      )
    div
      el-card(shadow="hover").card-collapse
        app-despachos(
          :idProcesso="idProcesso",
          :data="dadosCadastros.setores",
          @getDownload="getDownload",
          @getAnotacao="getAnotacao"
          :tituloMinuta="dadosCadastros.despacho.processo.tipo.codigo === 'CERTIDAO_TITULO' ? 'Minuta da certidão' : 'Minuta do título'"
        )
      el-card(
        shadow="hover"
        v-if="dadosVtn")
        el-collapse
          el-collapse-item(title='Dados do VTN')
            el-card(shadow="hover")
              visualizar-vtn(
                v-if="dadosVtn"
                :vtn="dadosVtn"
                :processo="processo",
                :exibeObs="false"
                :escolheuExterno="dadosVtn.status !== 'Criado'"
              )
      el-card(v-if="isArquivamentoIndeferimento && responseAnalise.inserirDocumentoDeArquivamento && this.isMa && !this.isReurbIndividual")
        app-label(
          label="Inclua a Carta de Notificação ao Interessado"
          :required="isValidateCarta !== ''"
        )
        validation-provider(:rules="isValidateCarta", v-slot="{ errors }")
          app-anexo(
            :id="'upload-carta-notificacao'"
            @uploadFile="uploadCartaNotificacao",
            :files="cartas",
            @removeFile="removeCartaNotificacao",
            :showAnexar="true"
            :errors="errors"
            @downloadDocumentoCadastro="getDownload",
            :tiposArquivosPermitidos="tiposArquivosPermitidosMapas"
            v-model="cartas"
            :showUpload="cartas.length === 0"
          )
      el-card(
        shadow="hover"
        v-if="documentosValidar && !isPublicacaoDoe && !isRetornarOuArquivar && processo.setor === 'GCQ' && dadosCadastro.dadosCadastro && dadosCadastro.dadosCadastro.dados.cadastro.beneficiarios.length"
      ).card-collapse
        el-table.margin-bottom(
          :data="[{qtde: dadosCadastro.dadosCadastro.dados.cadastro.beneficiarios.length}]"
        )
          el-table-column(
            label="Quantidade de beneficiários"
            prop="qtde"
          )
          el-table-column(
            :width='250'
          )
            template(slot-scope='scope')
              div.flex-end
                app-action-button(
                  innerText="Visualizar beneficiários"
                  icone="eye"
                  text="Visualizar beneficiários"
                  fontSize="18"
                  @click="showModalBeneficiarios = true"
                )
      app-dados-cadastro(
        v-if="(documentosValidar && !isPublicacaoDoe && !isRetornarOuArquivar && showValidacaoDocumentos) || (this.isMa && dadosCadastro && !isRetornarOuArquivar && documentosValidar)"
        :dadosCadastros="!this.isMa ? dadosCadastros.dadosCadastros : documentosFiltrados()",
        @setValidacaoDocumentos="setValidacaoDocumentos",
        @downloadDocumentoCadastro="downloadDocumentoCadastro"
        @setDocumentosValidar="setDocumentosValidar"
      )
    el-card(shadow="hover", v-if="(isPublicacaoDoe || isPublicacaoNutit) && !isRetornarOuArquivar && processo.setor !== 'GCQ'").card-collapse
      app-publicacao(
        :anexoPublicacao="anexoPublicacao ? [anexoPublicacao] : []"
        :numeroDoe="numeroDoe",
        :dataPublicacao="dataPublicacao"
        @setAnexoPublicacao="setAnexoPublicacao"
        @setPublicacaoNumero="setPublicacaoNumero"
        @setPublicacaoData="setPublicacaoData"
        @removeAnexoPublicacao="removeAnexoPublicacao"
        @downloadDocumentoCadastro="downloadDocumentoCadastro",
        :blockFutureDate="true"
      )
    el-card(shadow="hover", v-if="regras.showArquivosBloqueio || regras.showArquivosMonitoramento").card-collapse
      el-collapse
        el-collapse-item(title='Resposta do Interessado')
          app-visualizar-conversa(:conversa="responseAnalise.dadosMonitoramento.defesa")
    el-card(shadow="hover", v-if="regras.showArquivosBloqueio || regras.showArquivosMonitoramento")
      app-visualizar-monitoramento-area-tab(:idProcesso="processo.id", :numeroProcesso="processo.numeroProcesso")
    el-card(shadow="hover", v-if="(regras.showMapa || isGeoMenssura) && !isRetornarOuArquivar")
      app-label(
        label="Mapas"
        :required="isValidate !== ''"
      )
      validation-provider(:rules="isValidate !== ''", v-slot="{ errors }")
        app-anexo(
          :id="'upload-mapas'"
          @uploadFile="uploadMapa",
          :files="mapas",
          @removeFile="removeMapa",
          :showAnexar="true"
          :errors="errors"
          @downloadDocumentoCadastro="getDownload",
          :tiposArquivosPermitidos="tiposArquivosPermitidosMapas"
          v-model="mapas"
          :showUpload="isReurb ? mapas.length === 0 : true"
        )
    el-card(shadow="hover", v-if="dadosCadastros.isEmissaoCustas && !isRetornarOuArquivar").card-collapse
      app-geracao-custas(
        :custa="dadosCadastros.despacho.custa",
        :exibirLabelCustas="true",
        :exibirNumeroModulos="false",
        :exibirFatorLocalizacao="true",
        :exibirElaboracaoPublicacao="false",
        :exibirDataVencimento="false",
        :processo="processo"
      )
    el-card(shadow="hover", v-if="(dadosCadastros.isEmissaoDaeExterno && !isRetornarOuArquivar) || (isRevisaoDadosCusta)").card-collapse
      app-emitir-dae-externo(
        :dadosBoletoDespacho="dadosCadastros.despacho.dadosBoletoDespacho"
      )
    el-card(shadow="hover", v-if="dadosCadastros.despacho && hasAnexoDocumento && !isRetornarOuArquivar").card-collapse
      app-documentos(
        :isAnalise="true"
        :idUploadDocumento="componenteAnexoDocumento.idUploadDocumento"
        :titulo="componenteAnexoDocumento.titulo"
        :maxSize='5000',
        :valid-extensions="['png','jpg','jpeg','pdf','doc','docx']",
        :documentos="componenteAnexoDocumento.documentos"
        :tiposDocumentos="componenteAnexoDocumento.tiposDocumentos"
        :tiposDocumentosObrigatorios="componenteAnexoDocumento.tiposDocumentosObrigatorios"
        :pecasTecnicas="true"
        :removeOutros="true"
        @removedDoc="removeFile"
        :aba="componenteAnexoDocumento.aba"
        :observer="this.$refs.validation",
        :isValidacaoPeloMenosUmDocumento="this.isMa ? false : isValidacaoPeloMenosUmDocumento"
      )
    el-card(shadow="hover", v-if="dadosCadastros.despacho && isRatificacaoPoligono && !isRetornarOuArquivar && processo.tipo.codigo !== 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'").card-collapse
      div
          validation-provider(:rules="isRequiredRatificacaoPoligono", v-slot="{ errors }", name="Georreferenciamento/Geometria")
            mapa-analise-geomensor(
              v-model="dadosCadastros.despacho.localizacoes",
              :localizacoes="dadosCadastros.despacho.localizacoes"
              name="Geometria",
              idMapa="mapaAnaliseRatificacaoPoligono"
              :errors="errors"
            )
            span.help.erro {{ errors[0] }}

    el-card(shadow="hover", v-if="this.showSecaoDadosImovel").card-collapse
      app-formulario-analise-dados-imovel(:municipios="this.municipios", :dadosImovel="dadosImovelComponente", :isReurbIndividual="this.isReurbIndividual", :isOnerosoNaoOneroso="this.isOnerosoNaoOneroso", :isMa="this.isMa")

    el-card(shadow="hover", v-if="dadosCadastros.pecasTecnicas.length > 0 && !isRetornarOuArquivar").card-collapse
      p.label Peças Técnicas do cadastro
      el-table(:data="dadosCadastros.pecasTecnicas", :show-header="false")
        el-table-column(
          prop="tipo.descricao"
        )
        el-table-column(
          prop="nome"
        )
        el-table-column(
          align="right"
          width="110"
        )
          template(slot-scope="scope")
            el-tooltip.item(
              effect='dark',
              content='Baixar arquivo',
              placement="left"
            )
              el-button.button(@click="getDownload({id: scope.row.id, nome: scope.row.nome, caminho: scope.row.caminho})")
                font-awesome-icon(icon="download", size="lg")
    el-card(shadow="hover", v-if="showGeorreferenciamento").card-collapse
      app-documentos(
        @mudaTipo="mudaTipo",
        :isAnalise="true"
        :idUploadDocumento="'documentoGeorreferenciamento'"
        :titulo="'Georreferenciamento'"
        :maxSize='5000',
        :valid-extensions="extensoes",
        :documentos="anexosGeorreferenciamento"
        :tiposDocumentos="tipoDocumentosGeo"
        :tiposDocumentosObrigatorios="getDocumentosGeo.obrigatorios"
        :pecasTecnicas="true"
        :removeOutros="true"
        @removedDoc="removeFile"
        aba="Portaria"
        :observer="this.$refs.validation"
      )
      div(v-if="!isRetornarOuArquivar")
        validation-provider(:rules="isValidate || isValidateGeo", v-slot="{ errors }", name="Georreferenciamento/Geometria")
          mapa-analise-geomensor(
            v-model="dadosCadastros.despacho.localizacoes",
            :localizacoes="dadosCadastros.despacho.localizacoes"
            name="Geometria",
            idMapa="mapaAnaliseGeomensor"
            :errors="errors"
            @dataEmitted="receiveDataFromChild"
          )
          span.help.erro {{ errors[0] }}

    el-card(shadow="hover", v-if="uploadDoTermoOuContrato && !isRetornarOuArquivar && !isDecisao && !isAguardandoEntregaCertidao && !djAnaliseConjunta").card-collapse
      .radios-despacho-parecer
        validation-provider(rules="required", v-slot="{ errors }")
          .container-buttons
            el-radio-group(
              v-model="isDecisao",
              name="parecer",
            )
              div.padding.input(:class="{'erro' : errors.length}")
                el-radio(:label="false", :border="true") {{ decisao.primeiro }}
                el-radio(:label="true", :border="true") {{ getValueDecisao }}
            span.help.erro {{ errors[0] }}
    el-card(shadow="hover",v-if="uploadDoTermoOuContrato && !isRetornarOuArquivar && !isDecisao").card-collapse
      p.label {{ isEstadoAP ? 'Upload da Declaração de entrega de título' : uploadDoTermoOuContrato? 'Upload do termo de recebimento ou contrato' : 'Upload do termo de recebimento' }}
        span(v-if="!isSelectedRetornarEmissaoReurb").required &nbsp * &nbsp
      validation-provider(:rules="!isSelectedRetornarEmissaoReurb ? isValidateTermoRecebimento : ''", v-slot="{ errors }")
        app-anexo(
          :id="'upload-termo'"
          @uploadFile="uploadTermoRecebimento",
          :files="buscarDocumentoTermo(termoRecebimento)",
          @removeFile="removeTermoRecebimento",
          :showAnexar="true"
          :errors="!isSelectedRetornarEmissaoReurb ? errors : []"
          @downloadDocumentoCadastro="getDownload",
        )
    el-card(v-if="dadosCadastros.despacho.processo.tipo.codigo === 'CERTIDAO_TITULO' && processo.status === 'AGUARDANDO_PUBLICACAO'")
      p.label Upload do termo de retificação
        span.required &nbsp * &nbsp
      app-anexo(
        :id="'upload-termo-retificacao'"
        @uploadFile="uploadTermoRetificacao",
        :files="termoRetificacao"
        @removeFile="removeTermoRetificacao",
        :showAnexar="true"
        @downloadDocumentoCadastro="getDownload",
      )
    el-card(shadow="hover",v-if="isAguardandoEdital && !isRetornarOuArquivar && !isDecisao").card-collapse
      app-label(
        label="Edital"
        :required="isValidateEdital !== ''"
      )
      validation-provider(:rules="isValidateEdital", v-slot="{ errors }")
        app-anexo(
          :id="'upload-edital'"
          @uploadFile="uploadEdital",
          :files="anexosPublicacaoEdital",
          @removeFile="removeEdital"
          :showAnexar="true"
          :errors="errors"
          @downloadDocumentoCadastro="getDownload",
        )
    el-card(shadow="hover",v-if="isEstadoAP && isAnaliseDeTituloDirot && this.bytes != null").card-collapse
      p.label Título
      app-pdf-viewer-old(
        :bytes="bytes"
      )
      div.download-button
        el-button.btn(
          type="default"
          @click="downloadPdf()"
        )
          | Download PDF &nbsp
          i.fa.fa-download
    el-card(shadow="hover",v-if="dadosCadastros").card-collapse
      div(v-if="showDespachoAndAnexo()")
        .radios-despacho-parecer(v-if="regras.showButtonsDecisao && !isArquivamento && !djAnaliseConjunta || (isReurb && isDiretorJuridico)")
          validation-provider(rules="required", v-slot="{ errors }")
            .container-buttons
              el-radio-group(
                v-model="isDecisao",
                name="parecer",
              )
                div.padding.input(:class="{'erro' : errors.length}")
                  el-radio(:label="false", :border="true") {{ decisao.primeiro }}
                  el-radio(:label="true", :border="true") {{ getValueDecisao }}
              span.help.erro {{ errors[0] }}
        validation-provider(rules="required", v-slot="{ errors }")
          .flex-despacho
            p.label {{ formatterTipoDespacho }}
              span.required &nbsp * &nbsp
              el-tooltip.item(
                v-if="dadosCadastros.despacho.tipo === 'ENTREGA_TITULO' && !isDecisao && !isEstadoAP"
                effect="light"
                content='Informe o local onde o título será armazenado',
                placement="right"
              )
                font-awesome-icon(icon="info-circle")
            el-button(type="primary", @click="openModalDespacho" v-if="regras.showModelo") Modelo &nbsp
              .fa.fa-file

          app-editor-texto.input(
            @onTextChange="onTextChange",
            v-model="dadosCadastros.despacho.textoDespacho",
            :class="{'erro' : errors.length}"
            ref="editorTexto"
          )
          span.help.erro {{ errors[0] }}
        app-anexo(
          :id="'upload-anexo-despacho'",
          v-if="anexos && dadosCadastros.despacho && dadosCadastros.despacho.documentos.length === 0",
          @uploadFile="uploadFile",
          :files="anexos",
          @removeFile="removeFile"
          @downloadDocumentoCadastro="downloadDocumentoCadastro",
          :tipoExibir="'ANEXO_ANALISE'"
        )
      app-radios-tramitacao(
        :radios="acoesRadio",
        :isDecisao="isDecisao",
        :processo="processo",
        :isEsconderEncaminhamento="dadosCadastros.encaminhamento"
        @changeRadio="changeRadio",
        :radioInicial="dadosCadastros.despacho.acao",
        v-if="showButtonsTramitacao"
      )
      el-row(:gutter="20", v-if="showRadioRealizarGeorreferenciamento").top-georreferenciamento
        el-col(:span='24')
          p É necessário realizar o georreferenciamento ?
          validation-provider(rules="required", v-slot="{ errors }")
            el-radio-group(
              v-model="isRealizarGeorreferenciamento",
              name="parecer",
            )
              div.padding.input
                el-radio(:label="true", :border="true") Sim
                el-radio(:label="false", :border="true") Não
            span.help.erro {{ errors[0] }}
    app-buttons-cadastro.buttonValidarProcesso(
      :isUltimoPasso="isUltimoPasso",
      :isPrimeiroPasso="!isUltimoPasso",
      :showButtonSalvar="showSalvar",
      :showButtonProximo="showButtonProximo"
      @finalizar="finalizar",
      @cancelar="cancelar",
      @proximo="proximo",
      @salvar="salvar",
      :showButtonAnaliseManual="mudarParaAnaliseAutomatizada",
      labelButtonAnaliseManual="Análise automatizada",
      @changeAnalise="changeAnalise",
      @voltar="voltar"
    )
</template>
<script>
import utils, { conversaoArea, numberToStringDouble, stringToArrayBuffer, formatArea } from '@/utils/utils'
import FileSaver from 'file-saver'
import AppDespachos from '@/components/AppDespachos'
import AppDadosCadastro from '@/components/AppDadosCadastro.vue'
import AppActionButton from '@/components/AppActionButton.vue'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppAnexo from '@/components/AppAnexo'
import AppEmitirDaeExterno from '@/components/AppEmitirDaeExterno'
import AppGeracaoCustas from '@/components/AppGeracaoCustas'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalSelecionarModeloNotificacao from './components/AppModalSelecionarModeloNotificacao'
import { mapActions } from 'vuex'
import AppDisplay from '@/components/AppDisplay'
import AppPublicacao from '@/components/AppPublicacao'
import AppDivider from '@/components/AppDivider'
import AppDownloadAnexo from '@/components/AppDownloadAnexo'
import AppDadosGeraisOs from '@/components/AppDadosGeraisOs'
import AppLabel from '@/components/AppLabel'
import AppModalBeneficiario from '@/screens/analise/components/modal/AppModalBeneficiario.vue'
import AppVisualizarMonitoramentoAreaTab from '@/screens/analise/components/modal/AppVisualizarMonitoramentoAreaTab'
import AppDocumentos from '../central/components/cadastro/AppDocumentos'
import MapaAnaliseGeomensor from '@/screens/analise/components/MapaAnaliseGeomensor'
import _ from 'lodash'
import AnaliseAutomatizada from './AnaliseAutomatizada'
import statusProcesso from '@/utils/status'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import ConfirmarDados from '@/screens/analise/vtn/components/ConfirmarDados.vue'
import VisualizarVtn from '@/screens/analise/vtn/VisualizarVtn.vue'
import AppVisualizarConversa from '@/screens/central/components/centralMensagens/AppVisualizarConversa.vue'
import {getXmlFluxo} from '@/utils/manutencao'
import { parseString } from 'xml2js'
import AppFormularioAnaliseDadosImovel from './components/AppFormularioAnaliseDadosImovel'
import AppPdfViewerOld from '@/components/AppPDFViewerOld'
import FileHelper from '@/utils/fileHelper'

const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

const {
  tiposDocumentosVistoria,
  tiposDocumentosPortaria,
  tiposDocumentosGeorreferenciamento,
  isParecer,
  tiposDocumentosSpu,
  tiposDocumentosSpuResposta,
  tiposDocumentosArquivosPublicacao,
  tiposDocumentosRelatorio,
  tiposDocumentosPublicacaoEdital,
  tiposDocumentosPge,
  tiposDocumentosDecreto,
  tiposDocumentosDecisaoFinal,
  tiposDocumentosPds,
  tiposDocumentosIncra,
  isCertidao,
  cadastro,
  isCheckedRetornarEmissaoReurb,
  tiposModeloDefault,
  isOpcoesGeo,
  tiposDocumentosRurb,
  showGeorreferenciamentoAnexarDocumentosEShape,
  isAnaliseAutomatizada,
  tiposDocumentosGabinete
} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

const { setores } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  components: {
    AppDespachos,
    AppDadosCadastro,
    AppEditorTexto,
    AppButtonsCadastro,
    AppAnexo,
    AppActionButton,
    AppRadiosTramitacao,
    AppModalSelecionarModeloNotificacao,
    AppVisualizarMonitoramentoAreaTab,
    AppDisplay,
    AppPublicacao,
    AppDivider,
    AppDownloadAnexo,
    AppDadosGeraisOs,
    AppLabel,
    AppDocumentos,
    AnaliseAutomatizada,
    AppEmitirDaeExterno,
    MapaAnaliseGeomensor,
    AppGeracaoCustas,
    AppModalBeneficiario,
    AppHeaderDadosProcesso,
    ConfirmarDados,
    VisualizarVtn,
    AppVisualizarConversa,
    AppFormularioAnaliseDadosImovel,
    AppPdfViewerOld
  },

  mixins: [AppNotificacao],

  props: {
    responseAnalise: {
      required: true
    },
    processo: {
      required: true
    },
    idProcesso: {
      required: true
    },
    acaoCaixa: {
      type: String,
      default: null
    },
    regras: {
      required: true
    },
    active: {
      type: Number
    },
    hasAnalisePendente: {
      type: Boolean,
      default: false
    },
    analiseManual: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    showGeorreferenciamento () {
      return this.dadosCadastros.despacho && (this.isGeoMenssura || this.isGeoOnly) &&
        !this.isRetornarOuArquivar && this.getDocumentosGeo &&
        this.processo.tipo.codigo !== 'CANCELAMENTO_CLAUSULA_RESOLUTIVA' &&
        showGeorreferenciamentoAnexarDocumentosEShape
    },
    isReurb () {
      return this?.processo?.tipo?.codigo === 'REGULARIZACAO_URBANA'
    },
    getDocumentosGeo () {
      const documentos = JSON.parse(
        JSON.stringify(tiposDocumentosGeorreferenciamento)
      )
      if (this?.dadosCadastros?.isAnalisePreliminarGEO || this.dadosCadastros?.isDocumentosGeoRevisao) {
        documentos.obrigatorios = []
      } else if (this?.dadosCadastros?.isAnaliseValidacaoGEO && !this.dadosCadastros?.isDocumentosGeoRevisao) {
        documentos.obrigatorios = [
          { id: 148, codigo: 'ARQUIVO_SIGEF', descricao: 'Arquivos SIGEF' }
        ]
      } else if (this.isGeoOnly) {
        if (
          this.processo.status === 'EM_ANALISE' &&
          this.processo.setor === 'COMISSAO_ILHA' &&
          this.tipoDocumentosGeo.some(doc => doc.codigo === 'CRF')
        ) {
          documentos.obrigatorios = [{ id: 357, codigo: 'CRF', descricao: 'CRF' }]
        } else {
          documentos.obrigatorios = []
        }
      }
      return documentos
    },
    isPublicacao () {
      return (
        this.processo.status === statusProcesso.ENVIADO_PARA_PUBLICACAO ||
        this.processo.status === statusProcesso.EM_PUBLICACAO_PORTARIA || this.processo.status === statusProcesso.AGUARDANDO_PUBLICACAO
      )
    },
    isEncaminhar () {
      if (this?.dadosCadastros?.despacho?.acao) {
        return this?.dadosCadastros?.despacho?.acao.includes('FINALIZAR')
      }
      return false
    },
    isRetornarOuArquivar () {
      if (this.processo.status === statusProcesso.EM_ARQUIVAMENTO) {
        return false
      }
      if (this.dadosCadastros?.isDocumentosGeoRevisao) {
        return this?.dadosCadastros?.despacho?.acao
          ? this?.dadosCadastros?.despacho?.acao.includes('ARQUIVA')
          : false
      }
      return this?.dadosCadastros?.despacho?.acao
        ? this?.dadosCadastros?.despacho?.acao.includes('RETORNO') ||
            this?.dadosCadastros?.despacho?.acao.includes('ARQUIVA') ||
            this?.dadosCadastros?.despacho?.acao.includes('CAF_REVISAO')
        : false
    },
    isArquivamento () {
      return this.acoesRadio.some(
        radio => radio.valor === 'ARQUIVAR.GERENTE.GDA'
      )
    },
    isAnaliseAnalistaDadosCusta () {
      return this?.dadosCadastros?.despacho?.acao?.includes('VALIDACAO')
    },
    isRevisaoDadosCusta () {
      return this.processo.status === statusProcesso.EM_REVISAO_CADASTRO_DADOS_CUSTA
    },
    isArquivamentoIndeferimento () {
      return this?.dadosCadastros?.despacho?.acao?.includes('ARQUIVAMENTO') && !this?.dadosCadastros?.despacho?.acao?.includes('DESARQUIVAMENTO') && !this?.dadosCadastros?.despacho?.acao?.includes('VALIDADO_RETORNO_ARQUIVAMENTO')
    },
    showRadioRealizarGeorreferenciamento () {
      return isOpcoesGeo(this.user.perfilSelecionado.codigo, this.processo.status) &&
        this.dadosCadastros?.despacho?.acao && this.dadosCadastros?.despacho?.acao !== '' &&
        (this.dadosCadastros?.despacho?.acao.includes('FINALIZAR') || this.dadosCadastros?.despacho?.acao.includes('VALIDADO'))
    },

    showSalvar () {
      switch (this.processo.status) {
        case 'AGUARDANDO_PUBLICACAO':
        case 'ENVIADO_PARA_PUBLICACAO':
          return false
        default:
          return true
      }
    },
    formatterTipoDespacho () {
      if (
        this.dadosCadastros.despacho.tipo === 'ENTREGA_TITULO' &&
        !this.isDecisao && !this.isEstadoAP
      ) {
        return 'Armazenamento'
      }
      if (isParecer[this.processo.setor]) {
        return 'Parecer'
      }
      return 'Despacho'
    },

    isPublicacaoDoe () {
      return this.processo.status === statusProcesso.ENVIADO_PARA_PUBLICACAO || this.processo.status === statusProcesso.EM_PUBLICACAO_PORTARIA
    },
    isPublicacaoNutit () {
      return this.processo.status === statusProcesso.ENVIADO_PARA_PUBLICACAO || this.processo.status === statusProcesso.AGUARDANDO_PUBLICACAO
    },
    isValidate () {
      return this.mapas.length === 0 && this.dadosCadastros.mapaObrigatoria && !this.dadosCadastros?.isDocumentosGeoRevisao ? 'required' : ''
    },

    isValidateGeo () {
      return this.dadosCadastros.geoObrigatoria ? 'required' : ''
    },

    isValidateTermoRecebimento () {
      return this.termoRecebimento?.length === 0 ? 'required' : ''
    },

    isValidateEdital () {
      return this.anexosPublicacaoEdital?.length === 0 ? 'required' : ''
    },

    isValidateCarta () {
      return this.cartas?.length === 0 ? 'required' : ''
    },

    isRequiredRatificacaoPoligono () {
      return this.dadosCadastros?.isRequiredRatificacaoPoligono ? 'required' : ''
    },

    isAnaliseAutomatizada () {
      if (
        !this.groupAnaliseAutomatizada ||
        this.analiseManual
      ) {
        return false
      }

      return true
    },
    hasAnaliseAutomatizada () {
      return isAnaliseAutomatizada(this.groupAnaliseAutomatizada, this.analiseManual, this.processo)
    },

    mudarParaAnaliseAutomatizada () {
      return (
        this.groupAnaliseAutomatizada &&
        !this.dadosCadastros.despacho.flagAnaliseAutomatizada
      )
    },

    isValidacao () {
      return this.processo.status === statusProcesso.AGUARDANDO_VALIDACAO
    },

    uploadDoTermoOuContrato () {
      return this.isMa ? false : this.acaoCaixa === 'ACUSAR_ENTREGA'
    },

    tipoDocumentoTermoUpload () {
      return this.uploadDoTermoOuContrato
        ? this.documentoTermoOuContrato
        : this.documentoTermoRecebimento
    },

    isGeoMenssura () {
      return this.dadosCadastros?.showAdicionarDocumentoGeomensura
    },

    isGeoOnly () {
      return this.dadosCadastros?.showDocumentoGeomensura
    },

    isAnaliseGEO () {
      return this.dadosCadastros?.mapaObrigatoria
    },

    isEmAnaliseValidacaoGeo () {
      return this.dadosCadastros?.geoObrigatoria
    },

    isRatificacaoPoligono () {
      return this.dadosCadastros?.showRatificacaoPoligono
    },

    isAnaliseSpu () {
      return this.dadosCadastros?.showAnaliseSpu
    },

    isRespostaSpu () {
      return this.dadosCadastros?.showAnaliseRespostaSpu
    },

    isAnaliseArquivamento () {
      return this.dadosCadastros?.showAnaliseArquivamento
    },

    isAnaliseRelatorio () {
      return this.dadosCadastros?.showAnaliseRelatorio
    },

    isPublicacaoEdital () {
      return this.dadosCadastros?.showPublicacaoEdital
    },

    isAnaliseCasaCivil () {
      return this.dadosCadastros?.showAnaliseCasaCivil
    },

    isAnalisePge () {
      return this.dadosCadastros?.showAnalisePge
    },

    isAnalisePds () {
      return this.dadosCadastros?.showAnalisePds
    },

    isAnaliseIncra () {
      return this.dadosCadastros?.showAnaliseIncra
    },

    isDecisaoFinal () {
      return this.dadosCadastros?.showDecisaoFinal
    },

    showButtonsTramitacao () {
      return (
        (!cadastro.statusBotoesDecisao.status.includes(this.processo?.status) ||
        cadastro.statusBotoesDecisao.despacho.includes(
          this.dadosCadastros?.despacho?.tipo
        ))
      )
    },

    getValueDecisao () {
      return this.decisao.terceiro && isCertidao(this.processo?.tipo.codigo)
        ? this.decisao.terceiro
        : this.decisao.segundo
    },

    isAguardandoEntregaCertidao () {
      return this.processo.status === 'AGUARDANDO_ENTREGA'
    },

    isAguardandoEdital () {
      return this.processo.status === 'AGUARDANDO_EDITAL'
    },

    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    },

    isOnerosoNaoOneroso () {
      return ['ONEROSO', 'NAO_ONEROSO', 'NAO_ONEROSO_FISICO', 'ONEROSO_FISICO'].includes(this.processo.tipo.codigo)
    },

    isReurbIndividual () {
      return ['REURB_INDIVIDUAL'].includes(this.processo.tipo.codigo)
    },

    showSecaoDadosImovel () {
      return (this.dadosCadastros?.showAdicionarDadosImovel && !this.isRetornarOuArquivar) || (this.processo.status === 'EM_ANALISE_MALHA_FUNDIARIA' && process.env.ESTADO === 'ma' && this.processo.setor === 'DATGL' && this.isOnerosoNaoOneroso && !this.isRetornarOuArquivar)
    },

    isAnaliseDeTituloDirot () {
      return (
        this.processo.setor === 'DIROT' && (this.processo.status === statusProcesso.AGUARDANDO_ANALISE_TITULO || this.processo.status === statusProcesso.EM_ANALISE_TITULO)
      )
    }
  },

  data () {
    return {
      dataDespachos: [],
      tiposArquivosPermitidosMapas: '.png, .jpg, .jpeg, .pdf, .doc, .docx',
      dadosCadastros: undefined,
      cartas: [],
      showModalDespacho: false,
      termoRecebimento: [],
      termoRetificacao: [],
      tiposModelo: tiposModeloDefault, // Despacho
      tituloModalModelo: 'Modelos de Despacho',
      anexos: [],
      radios: [],
      acoesRadio: [],
      anexosGeorreferenciamento: [],
      showModal: false,
      isFinalizada: false,
      showModalBeneficiarios: false,
      numeroProcesso: '',
      dataPublicacao: null,
      numeroDoe: null,
      anexoPublicacao: null,
      isDecisao: false, // variavel utilizado para selecionar a decisão de despacho selecionada e enviar para o componente que exibe os radios
      documentosValidar: true,
      isRealizarGeorreferenciamento: null,
      decisao: {},
      funcao: [],
      mapas: [],
      laudo: [],
      hasAnexoLaudo: false,
      hasAnexoDocumento: false,
      componenteAnexoDocumento: null,
      anexosVistoriador: [],
      anexosDocumentoReurb: [],
      anexosGabineteReurbIndividual: [],
      anexosSpu: [],
      anexosRespostaSpu: [],
      anexosArquivosPublicacao: [],
      anexosRelatorio: [],
      anexosPortaria: [],
      anexosPortariaMatricula: [],
      anexosPublicacaoEdital: [],
      anexosPge: [],
      anexosDecreto: [],
      anexosDecisaoFinal: [],
      anexosPds: [],
      anexosIncra: [],
      groupAnaliseAutomatizada: false,
      hasClickFinalizar: true,
      documentoTermoOuContrato: {
        id: 147,
        codigo: 'TERMO_RECEBIMENTO_CONTRATO'
      },
      documentoTermoRecebimento: {
        id: 111,
        codigo: 'TERMO_RECEBIMENTO'
      },
      documentoTermoRetificacao: {
        id: 197,
        codigo: 'TERMO_DE_RETIFICACAO'
      },
      dadosCadastro: [],
      numeroTituloDominial: null,
      numeroProcessoFisico: null,
      isSelectedRetornarEmissaoReurb: false,
      dataEmissaoTituloDominial: null,
      isCCR: false,
      dadosVtn: '',
      isUltimoPasso: true,
      showButtonProximo: false,
      extensoes: ['pdf', 'jpeg', 'png', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar', 'jpg', 'doc'],
      tipoDocumentosGeo: [],
      showValidacaoDocumentos: false,
      dadosAutomatizadaGeo: [],
      isPa: process.env.ESTADO === 'pa',
      isMa: process.env.ESTADO === 'ma',
      isBa: process.env.ESTADO === 'ba',
      isAp: process.env.ESTADO === 'ap',
      djAnaliseConjunta: false,
      user: null,
      isGit: false,
      isDiretorJuridico: false,
      municipios: [],
      dadosImovelComponente: {
        // idGleba: '', // vai ser adicionado
        gleba: '', // vai ser removido
        matricula: '', // vai ser removido
        livro: '', // vai ser removido
        folha: '', // vai ser removido
        cartorio: '', // vai ser removido
        latitude: '', // vai ser removido
        longitude: '', // vai ser removido
        municipioCartorio: '', // vai ser removido
        povoado: '',
        municipio: '',
        logradouro: '',
        numeroDeControle: '',
        quadraDeControle: '',
        areaOrigin: 0,
        areaImovel: 0,
        tipoArea: ''
      },
      bytes: null
    }
  },

  mounted () {
    if (process.env.ESTADO === 'pa') {
      this.dadosAutomatizadaGeo = [{
        label: '',
        data: [
          {
            base64: null,
            caminho: 'relatorio_geral.zip',
            documentoGeo: null,
            hash: null,
            id: 0,
            isValido: true,
            key: null,
            nome: 'Arquivo bruto - Georeferenciamento',
            publicado: null,
            tipo: {id: 0, descricao: 'RELATORIO GERAL', codigo: 'RELATORIO_GERAL'}
          }
        ],
        headers: [
          {titulo: 'Tipo de documento', propriedade: 'RELATORIO_GERAL', ordem: null, tipo: 'checkbox', acao: null}
        ],
        containsCRF: false
      }]
    }
  },

  async created () {
    this.municipios = await this.findMunicipiosByEstadoAtual() || []
    this.user = await this.getUsuario()
    this.isGit = this.user.perfilSelecionado.codigo.includes('GIT')
    this.isDiretorJuridico = this.user.perfilSelecionado.codigo === 'DIRETOR_JURIDICO_DJ'
    await this.montarTela()
    this.tipoDocumentosGeo = await this.findTiposDocumentoTipoProcesso({
      url: 'geo',
      tipo: this.processo.tipo.codigo
    })
    if (process.env.ESTADO === 'ap') {
      this.dadosVtn = await this.getVtnByIdProcesso(this.processo.id)
      if (this.isAnaliseDeTituloDirot) {
        const bytes = await this.getArrayTituloByProcessoId(this.processo.id)
        this.bytes = stringToArrayBuffer(bytes[bytes.length - 1].bytes)
      }
    }
    this.dadosCadastro = await this.getProcesso(this.processo.numeroProtocolo)
    this.containsCRF = this.dadosCadastro?.dadosCadastro?.imovel?.documentos?.some(
      doc => doc?.tipo?.codigo === 'CRF')
    if (this.containsCRF) {
      this.tipoDocumentosGeo = this.tipoDocumentosGeo.filter(tipo => tipo.codigo !== 'CRF')
    }
    this.isCCR = this.dadosCadastro.tipo.codigo === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
    if (this.isCCR) {
      this.numeroTituloDominial = this.dadosCadastro.dadosCadastro.numeroTituloDominial
      this.numeroProcessoFisico = this.dadosCadastro.dadosCadastro.numeroProcesso
      this.dataEmissaoTituloDominial = this.dadosCadastro.dadosCadastro.dataEmissaoTituloDominial
    }
    this.showValidacaoDocumentos = regrasAnalise.showValidacaoDocumentos.perfis.includes(this.user.perfilSelecionado.codigo) || this.dadosCadastros.showValidacaoVerificacao
    if (this.isMa) {
      this.dadosCadastros.despacho.tituloDespacho = {
        tituloProcesso: ''
      }
      if (this.dadosCadastro?.dadosCadastro?.dados?.cadastro?.georreferenciamento?.localizacoes?.length > 0) {
        this.dadosCadastros.despacho.localizacoes = this.dadosCadastro.dadosCadastro.dados.cadastro.georreferenciamento.localizacoes
      }
    }
  },

  methods: {
    documentosFiltrados () {
      if (this.processo.tipo.codigo === 'REURB_COLETIVO' && this.processo.setor === 'DRF') {
        const cadastro = this.dadosCadastros.dadosCadastros[0]
        if (!cadastro || !cadastro.data) return []

        return [{
          ...cadastro,
          data: cadastro.data.filter(
            doc => doc.tipo?.codigo !== 'CRF'
          )
        }]
      } else {
        return this.dadosCadastros.dadosCadastros
      }
    },
    mudaTipo (opcao) {
      switch (opcao.tipo) {
        case 'ARQUIVOS_LITERAIS':
        case 'ARQUIVOS_GRAFICOS':
        case 'ARQUIVOS_GNSS':
          this.extensoes = ['zip', 'rar']
          break
        case 'OUTROS_GEOMENSOR':
          this.extensoes = ['pdf', 'jpeg', 'png', 'jpg', 'doc', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar']
          break
      }
    },
    isCheckedRetornarEmissaoReurb,

    ...mapActions({
      tarefa: 'processo/tarefa',
      getSubcaixaAtual: 'processo/subcaixaAtual',
      getProcesso: 'processos/getProcessoByProtocolo',
      updateVtn: 'vtn/updateVtn',
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso',
      findTiposDocumentoTipoProcesso:
        'tipoDocumento/findTiposDocumentoTipoProcesso',
      getUsuario: 'auth/getUsuario',
      checkAnaliseManual: 'processo/checkAnaliseManual',
      statusDoProcesso: 'processo/statusProcessoFila',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtualPromise',
      getArrayTituloByProcessoId: 'despacho/getArrayTituloByProcessoId'
    }),

    formatDate (value) {
      return value ? utils.formatDate(value) : '-'
    },

    async proximo () {
      await this.salvar()
      window.location.href = `${process.env.URL_AUTOMATIZADO_GEO}/#/analises/${this.processo.id}`
    },

    showDespachoAndAnexo () {
      switch (this.processo.status) {
        case 'ENVIADO_PARA_PUBLICACAO':
        case 'AGUARDANDO_PUBLICACAO':
          if ((this.isRetornarOuArquivar && (this.isAp || this.processo.tipo.codigo === 'TEQ')) || this.processo.setor === 'GCQ') {
            return true
          }
          break
        case 'CADASTRANDO_DADOS_CUSTA':
          if (this.isAp && (this.isRetornarOuArquivar || this.isEncaminhar || this.isAnaliseAnalistaDadosCusta)) {
            return true
          }
          break
        case 'EM_PUBLICACAO_PORTARIA':
        case 'AGUARDANDO_TERMO_CONTRATO':
          return false
        default:
          return true
      }
    },

    mensagemAnaliseBemSucedida (setor, status) {
      if (status === 'ARQUIVADO') {
        return `Processo arquivado com sucesso`
      }
      if (!status && setor === 'GABINETE' && this.isMa) {
        return 'Análise finalizada.'
      }
      if (setor && setor !== '' && setor !== 'SISTEMA') {
        if (setor.includes('_')) {
          setor = setor.replace(/_/g, '/')
        }
        return `Análise finalizada. Processo enviado para o setor ${setor}.`
      } else {
        return 'Análise finalizada.'
      }
    },

    uploadMapa (file) {
      this.mapas.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 79,
          codigo: 'ANEXO_MAPA'
        }
      })
    },

    uploadCartaNotificacao (file) {
      this.cartas.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 341,
          codigo: 'CARTA_NOTIFICACAO_INTERESSADO'
        }
      })
    },

    uploadLaudo (file) {
      this.laudo.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 192,
          codigo: 'LAUDO_AUTOMATICO'
        }
      })
    },

    uploadTermoRecebimento (file) {
      const documento = {
        key: file.response,
        nome: file.name,
        tipo: {
          id: this.tipoDocumentoTermoUpload.id,
          codigo: this.tipoDocumentoTermoUpload.codigo
        }
      }
      if (!this.isBa) {
        this.removeTermoRecebimento(documento)
        this.termoRecebimento.push(documento)
      } else if (this.termoRecebimento?.length < 5) {
        this.termoRecebimento.push(documento)
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'N° máximo de anexos do termo de recebimento atingido'
        )
      }
    },
    removeTermoRecebimento (documento) {
      if (
        this.termoRecebimento.find(
          doc => doc.tipo.codigo === documento.tipo.codigo
        )
      ) {
        this.termoRecebimento.splice(
          this.termoRecebimento.findIndex(
            item => item.tipo.codigo === documento.tipo.codigo
          ),
          1
        )
      }
    },
    uploadTermoRetificacao (file) {
      const documento = {
        key: file.response,
        nome: file.name,
        tipo: {
          id: this.documentoTermoRetificacao.id,
          codigo: this.documentoTermoRetificacao.codigo
        }
      }

      this.termoRetificacao.push(documento)
    },
    removeTermoRetificacao (documento) {
      if (this.termoRetificacao.find(doc => doc.tipo.codigo === documento.tipo.codigo)) {
        this.termoRetificacao.splice(this.termoRetificacao.findIndex(item => item.tipo.codigo === documento.tipo.codigo), 1)
      }
    },
    removeMapa (documento) {
      const index = this.mapas.indexOf(
        this.mapas.find(m => m.key === documento.key)
      )
      this.mapas.splice(index, 1)
    },

    removeCartaNotificacao (documento) {
      const index = this.cartas.indexOf(
        this.cartas.find(m => m.key === documento.key)
      )
      this.cartas.splice(index, 1)
    },

    removeLaudo (documento) {
      const index = this.laudo.indexOf(
        this.laudo.find(l => l.key === documento.key)
      )
      this.laudo.splice(index, 1)
    },

    changeRadio (value) {
      this.dadosCadastros.despacho.acao = value.acao
      this.isSelectedRetornarEmissaoReurb = isCheckedRetornarEmissaoReurb(value.acao)
      if (value.usuario) {
        this.dadosCadastros.despacho.processo.usuarioEncaminhar = {
          id: value.usuario
        }
      }
    },

    atualizaVariaveisDeDecesao () {
      if (this.showRadioRealizarGeorreferenciamento) {
        this.dadosCadastros.despacho.isRealizarGeorreferenciamento = this.isRealizarGeorreferenciamento
      } else if (
        this?.dadosCadastros?.despacho?.acao &&
        (this?.dadosCadastros?.despacho?.acao.includes(
          'FINALIZAR.COMISSAO_ILHA_DOCUMENTAL.ANALISE_DOCUMENTAL'
        ) ||
          this?.dadosCadastros?.despacho?.acao.includes(
            'VALIDADO.CHEFE_SETOR.COMISSAO_ILHA_DOCUMENTAL.AUTOCOMPLETE'
          ))
      ) {
        this.dadosCadastros.despacho.isRealizarGeorreferenciamento = true
      } else {
        this.dadosCadastros.despacho.isRealizarGeorreferenciamento = null
      }
    },

    removeEdital (documento) {
      if (this.anexosPublicacaoEdital.find(doc => doc.tipo.codigo === documento.tipo.codigo)) {
        this.anexosPublicacaoEdital.splice(this.anexosPublicacaoEdital.findIndex(item => item.tipo.codigo === documento.tipo.codigo), 1)
      }
    },

    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.id === documento.id)
        )
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.key === documento.key)
        )
        this.anexos.splice(index, 1)
      }
    },

    async getDownload (documento) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && documento.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = documento.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${documento.caminho.split(diretorio)[1]}`, documento?.tipo?.descricao || documento?.tipo, 'height=500,width=800,top=250px,left=250px,right=150px')

        return
      }
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    retornarCaixa () {
      switch (this.acaoCaixa) {
        case 'ANALISE':
          return 'EM_ANALISE'
        case 'VALIDACAO':
          return 'AGUARDANDO_VALIDACAO_ANALISE'
        default:
          return 'EM_ANALISE'
      }
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    downloadDocumentoAnaliseAutomatizadaGeo (documento) {
      this.getDownloadAutomatizadaGeo(documento)
    },
    downloadDocumentoRelatorioGeral (documento) {
      this.getDownloadRelatorioGeral(documento)
    },
    cancelar () {
      var rota = ''
      switch (this.acaoCaixa) {
        case 'ANALISE':
          rota = 'EM_ANALISE'
          break
        case 'VALIDAR':
          rota = 'VALIDACAO'
          break
        case 'ANALISE_SEM_TRAMITACAO':
          rota = 'CAIXA_ENTRADA'
          break
        case 'UPLOAD_TERMO_RECEBIMENTO_CONTRATO':
          rota = 'DOCUMENTOS'
          break
        case 'ELABORAR_EDITAL':
          rota = 'EDITAL_PUBLICACAO'
          break
        case 'ACUSAR_ENTREGA' :
          rota = 'TITULOS_PARA_ENTREGA'
          break
        default:
          rota = 'EM_ANALISE'
      }
      this.$router.push({
        name: rota
      })
    },

    setValidacaoDocumentos (dadosCadastor) {
      let i = 0
      this.dadosCadastros.dadosCadastros.map((dados, index) => {
        if (dados.tipo === dadosCadastor.tipo) {
          i = index
        }
      })
      this.dadosCadastros.dadosCadastros[i] = dadosCadastor
    },

    setIsDecisao () {
      this.isDecisao = this.acoesRadio.some(
        radio => radio.valor === 'ARQUIVAR.GERENTE.GDA' || radio.valor === 'SOLICITAR_ARQUIVAMENTO.DIRETOR_JURIDICO.GDA.AUTOCOMPLETE'
      )
    },

    onTextChange (text) {
      this.dadosCadastros.despacho.textoDespacho = text
    },

    getAnotacao (emit) {
      this.dataDespachos[emit.indexItem].despachos[emit.indexSubItem].anotacao =
        emit.value
    },

    downloadPdf () {
      FileHelper.saveFile(
        this.bytes,
        this.processo.tipo.codigo === 'CERTIDAO_TITULO'
          ? 'minuta da certidão'
          : 'minuta do título'
      )
    },

    async salvarAnotacao () {
      try {
        if (this.regras.podeInserirAnotacao) {
          let despachosAnotacao = []
          this.dataDespachos.map(setor => {
            setor.despachos.map(d => {
              despachosAnotacao.push({
                id: d.id,
                anotacao: d.anotacao
              })
            })
          })

          await axios({
            method: 'post',
            data: despachosAnotacao,
            url: 'despacho/salvarAnotacao',
            error: true
          })
        }
      } catch (error) {
        const messagemDeErro = Array.isArray(error.erros)
          ? error.erros.join(';')
          : 'Houve um erro ao salvar a análise.'
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          messagemDeErro
        )
      }
    },

    // TODO: MESCLAR METODOS SALVAR E FINALIZAR (REFACTOR)
    async salvar () {
      try {
        await this.atualizaDocumentos()
        await this.salvarAnotacao()
        this.atualizaVariaveisDeDecesao()
        this.setDadosImovelDespacho()
        if (this.isPublicacao && this.anexoPublicacao) {
          this.setPublicacao()
        }

        if (!this.isValidacao) {
          this.setMapas()
          this.mapas = []
          this.setLaudo()
          this.laudo = []
        }

        if (this.isArquivamentoIndeferimento && this.responseAnalise.inserirDocumentoDeArquivamento) {
          this.setCartaNotificacaoInteressado()
          this.cartas = []
        }

        if (
          this.acaoCaixa === 'UPLOAD_TERMO_RECEBIMENTO_CONTRATO' ||
          this.processo.status === 'AGUARDANDO_ENTREGA'
        ) {
          this.setTermoRecebimento()
        }
        if (this.termoRetificacao.length > 0) {
          this.setTermoRetificacao()
        }
        await axios({
          method: 'post',
          data: this.dadosCadastros.despacho,
          url: 'despacho/salvar',
          error: true
        })
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Análise salva!'
        )
        this.dadosCadastros.despacho.documentos = []
        await this.$emit('atualizarTela')
      } catch (error) {
        const messagemDeErro = Array.isArray(error.erros)
          ? error.erros.join(';')
          : 'Houve um erro ao salvar a análise.'
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          messagemDeErro
        )
      }
    },

    setDadosImovelDespacho () {
      if (this.isMa && this.showSecaoDadosImovel) {
        if (this.dadosImovelComponente.tipoArea !== 'HECTARE' && !this.isReurbIndividual) {
          this.dadosImovelComponente.areaImovel = conversaoArea(this.dadosImovelComponente.areaOrigin, this.dadosImovelComponente.tipoArea)
        } else if (this.isReurbIndividual) {
          this.dadosImovelComponente.areaImovel = numberToStringDouble(this.dadosImovelComponente.areaOrigin)
          this.dadosImovelComponente.areaOrigin = formatArea(this.dadosImovelComponente.areaOrigin)
        } else {
          this.dadosImovelComponente.areaImovel = numberToStringDouble(this.dadosImovelComponente.areaOrigin)
        }
        this.dadosCadastros.despacho.tituloDespacho.tituloProcesso = JSON.stringify({
          dadosImovel: {
            ...this.dadosImovelComponente,
            data: new Date().toISOString()
          }
        })
      }
    },
    mensagemFinalizacao () {
      let acao = this.dadosCadastros?.despacho?.acao
      if (this.isMa && acao && (acao === 'RETORNO.SISTEMA.DATGL_TITULO' || acao === 'RETORNO.SISTEMA.CTRU_TITULO')) {
        return this.$messages.FINALIZAR_ANALISE_RETORNO_TITULO
      }
      return this.$messages.FINALIZAR_ANALISE
    },
    async finalizar () {
      if (!this.hasClickFinalizar) {
        return
      }
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
        return
      }

      this.confirmBox(
        this.mensagemFinalizacao(),
        this.$messages.TITULO_WARNING,
        async () => {
          try {
            this.hasClickFinalizar = false
            await this.atualizaDocumentos()
            await this.salvarAnotacao()
            this.atualizaVariaveisDeDecesao()
            this.setDadosImovelDespacho()
            if (this.isPublicacao && this.anexoPublicacao) {
              this.setPublicacao()
            }

            if (!this.isValidacao) {
              this.setMapas()
              this.mapas = []
              this.setLaudo()
              this.laudo = []
            }

            if (this.isArquivamentoIndeferimento && this.responseAnalise.inserirDocumentoDeArquivamento) {
              this.setCartaNotificacaoInteressado()
              this.cartas = []
            }

            if (
              this.acaoCaixa === 'UPLOAD_TERMO_RECEBIMENTO_CONTRATO' ||
              this.processo.status === 'AGUARDANDO_ENTREGA'
            ) {
              this.setTermoRecebimento()
            }
            if (
              this.dadosCadastros.despacho.acao === 'AGUARDANDO_CALCULO_VTN.COORDENADOR.CRF_VTN'
            ) {
              this.dadosVtn.idProcesso = this.processo.id
              this.dadosVtn.municipio = this.dadosVtn.pvtn.municipio
              this.dadosVtn.status = 'AGUARDANDO_CALCULO'
              this.dadosVtn.moduloFiscal = this.dadosVtn.municipio.mf
              this.dadosVtn.qtdModuloFiscal = this.dadosVtn.areaRequerida / this.dadosVtn.municipio.mf
              if (this.dadosVtn.formaPagamento && typeof this.dadosVtn.formaPagamento !== 'string' && this.isEstadoAP) {
                this.dadosVtn.formaPagamento = this.dadosVtn.formaPagamento.codigo
              }
              this.dadosVtn.percentualCalculado = this.dadosVtn.percentualAplicado * 100
              this.dadosCadastros.despacho.idVtn = this.dadosVtn.id
              this.updateVtn(this.dadosVtn)
            }

            if (
              this.dadosCadastros.despacho.acao === 'FINALIZAR.CRF_VTN.CALCULO_VTN'
            ) {
              this.dadosVtn.idProcesso = this.processo.id
              this.dadosVtn.status = 'ATIVO'
              this.dadosVtn.municipio = this.dadosVtn.pvtn.municipio
              this.dadosVtn.moduloFiscal = this.dadosVtn.municipio.mf
              this.dadosVtn.qtdModuloFiscal = this.dadosVtn.areaRequerida / this.dadosVtn.municipio.mf
              this.dadosVtn.percentualCalculado = this.dadosVtn.percentualAplicado * 100
              if (this.dadosVtn.formaPagamento && typeof this.dadosVtn.formaPagamento !== 'string' && this.isEstadoAP) {
                this.dadosVtn.formaPagamento = this.dadosVtn.formaPagamento.codigo
              }
              this.dadosCadastros.despacho.idVtn = this.dadosVtn.id
              this.updateVtn(this.dadosVtn)
            }

            if (!this.showDespachoAndAnexo()) {
              this.dadosCadastros.despacho.textoDespacho = ''
            }
            if (this.termoRetificacao.length > 0) {
              this.setTermoRetificacao()
            }
            if (this.isRetornarOuArquivar && this.isMa && !this.radios.name.includes('CAF_REVISAO')) {
              this.dadosCadastros.despacho.localizacoes = []
            }
            await axios({
              method: 'post',
              data: this.dadosCadastros.despacho,
              url: 'despacho/finalizar',
              error: true
            }).then(response => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.mensagemAnaliseBemSucedida(response.proximoSetor, response.proximoStatus)
              )
              this.hasClickFinalizar = true
              if (this.processo.setor === 'GEO') {
                this.$router.push({name: 'EM_ANALISE'})
              } else {
                this.$router.back()
              }
            }).catch(() => {
              this.hasClickFinalizar = true
            })
          } catch (error) {
            console.error(error)
          }
        }
      )
    },

    async atualizaDocumentos () {
      this.dadosCadastros.despacho.documentos = _.cloneDeep(this.anexos)
      if (this.isRetornarOuArquivar) {
        return
      }
      await this.dadosCadastros.dadosCadastros.map(dados => {
        if (dados.tipo === 'tabelaComCheck') {
          if (dados && dados.data) {
            dados.data.map(documento => {
              documento.id = null
              this.dadosCadastros.despacho.documentos.push(documento)
            })
          }
        }
      })
      if (this.isVistoria()) {
        await this.anexosVistoriador.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isDocumentoReurb()) {
        await this.anexosDocumentoReurb.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isAnaliseSpu) {
        await this.anexosSpu.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isRespostaSpu) {
        await this.anexosRespostaSpu.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isAnaliseArquivamento) {
        await this.anexosArquivosPublicacao.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isAnaliseRelatorio) {
        await this.anexosRelatorio.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isPublicacaoEdital) {
        await this.anexosPublicacaoEdital.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isAguardandoEdital) {
        await this.anexosPublicacaoEdital.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey || documento.key,
            nome: documento.fileName || documento.nome,
            tipo: documento.tipoDocumento || documento.tipo
          })
        })
      }
      if (this.isAnalisePge) {
        await this.anexosPge.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isAnaliseCasaCivil) {
        await this.anexosDecreto.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isDecisaoFinal) {
        await this.anexosDecisaoFinal.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isAnalisePds) {
        await this.anexosPds.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isAnaliseIncra) {
        await this.anexosIncra.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isPortaria()) {
        await this.anexosPortaria.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isMatricula()) {
        await this.anexosPortariaMatricula.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isGeoMenssura || this.isGeoOnly) {
        this.anexosGeorreferenciamento.forEach(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
      if (this.isDocumentoGabinete()) {
        await this.anexosGabineteReurbIndividual.map(documento => {
          this.dadosCadastros.despacho.documentos.push({
            id: typeof documento.id === 'string' ? null : documento.id,
            caminho: documento.caminho,
            key: documento.fileKey,
            nome: documento.fileName,
            tipo: documento.tipoDocumento
          })
        })
      }
    },

    uploadEdital (file) {
      this.anexosPublicacaoEdital.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 90,
          codigo: 'ANEXO_EDITAL'
        }
      })
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    showModalSelecionarModelo () {
      this.showModal = true
    },

    closeModal () {
      this.showModal = false
    },

    setTextoDespacho (textoDespacho) {
      this.$refs.editorTexto.text = textoDespacho
      this.$refs.editorTexto.emitTextChange()
    },

    openModalDespacho () {
      if (this.isReurb &&
        (this.processo.setor === 'DEAF' ||
          this.processo.setor === 'DJ' ||
          this.processo.setor === 'GP' ||
          this.processo.setor === 'GEO' ||
          setores.GCG_CGIR.includes(this.processo.setor))) {
        this.tiposModelo = [4]
        this.tituloModalModelo = 'Modelo de Despacho Reurb'
      }
      this.showModalDespacho = true
    },

    fecharModalDespacho () {
      this.showModalDespacho = false
    },

    setPublicacaoData (data) {
      this.dataPublicacao = data
    },

    setPublicacaoNumero (value) {
      this.numeroDoe = value
    },

    setAnexoPublicacao (anexo) {
      this.anexoPublicacao = anexo
    },

    setPublicacao () {
      this.dadosCadastros.despacho.numeroDoe = this.numeroDoe
      this.dadosCadastros.despacho.dataPublicacao = this.dataPublicacao
      if (Array.isArray(this.anexoPublicacao)) {
        this.anexoPublicacao.forEach(d => {
          this.dadosCadastros.despacho.documentos.push(d)
        })
      } else {
        this.dadosCadastros.despacho.documentos.push(this.anexoPublicacao)
      }
    },

    setMapas () {
      this.mapas.forEach(mapa => {
        this.dadosCadastros.despacho.documentos.push(mapa)
      })
    },

    setCartaNotificacaoInteressado () {
      this.cartas.forEach(carta => {
        this.dadosCadastros.despacho.documentos.push(carta)
      })
    },

    setLaudo () {
      this.laudo.forEach(l => {
        this.dadosCadastros.despacho.documentos.push(l)
      })
    },

    setTermoRecebimento () {
      this.termoRecebimento.filter(doc => doc.tipo.codigo === this.tipoDocumentoTermoUpload.codigo
      ).forEach(termo => this.dadosCadastros.despacho.documentos.push(termo))
      this.termoRecebimento = []
    },
    setTermoRetificacao () {
      this.dadosCadastros.despacho.documentos.push(this.termoRetificacao.find(doc => doc.tipo.codigo === 'TERMO_DE_RETIFICACAO'))
      this.termoRetificacao = []
    },

    removeAnexoPublicacao () {
      this.anexoPublicacao = null
      this.dadosCadastros.despacho.documentos = []
    },

    async reformulaNomesEncaminhamentos () {
      // Objetivo dessa função é trocar o 'encaminhar processo' para um nome melhor, indicando pra qual setor vai.
      // comentado pois em alguns casos o proximo setor da lista não condiz com fluxo de encaminhamento correto.
      const caixaAtual = await this.getSubcaixaAtual(this.idProcesso)

      const { xml } = await getXmlFluxo(this.processo.numeroProcesso, this.processo.tipo.codigo)
      parseString(xml, (_, results) => {
        const acoes = results.definitions.process[0].callActivity.map(o => ({
          nome: o['$'].name,
          acao: o['$'].id
        })).filter(e => !e.acao.includes('INICIAR'))
        const indiceAcaoAtual = acoes.findIndex(a => a.acao === caixaAtual)
        const acaoEncaminhamento = acoes[indiceAcaoAtual + 1]
        const indexEncaminhamento = this.acoesRadio.findIndex(radio => radio.nome.toLowerCase() === 'encaminhar processo' || radio.nome.toLowerCase() === 'encaminhar setor')
        if (indexEncaminhamento !== undefined) {
          this.acoesRadio[indexEncaminhamento].nome = `Encaminhar para ${acaoEncaminhamento.nome}`
        }
      })
    },

    setDocumentosValidar (validar) {
      this.documentosValidar = validar
    },

    adicionaDadosCamposMalha () {
      if (this.responseAnalise.dadosImovelDto && this.showSecaoDadosImovel) {
        const municipioImovel = this.municipios.find((obj) => obj.nome.toUpperCase() === this.responseAnalise.dadosImovelDto.municipioImovel)
        const municipioCartorio = this.municipios.find((obj) => obj.nome.toUpperCase() === this.responseAnalise.dadosImovelDto.municipioCartorio) // vai ser removido
        this.dadosImovelComponente.gleba = this.responseAnalise.dadosImovelDto.gleba || '' // vai ser removido

        this.dadosImovelComponente.matricula = this.responseAnalise.dadosImovelDto.matricula || '' // vai ser removido
        this.dadosImovelComponente.livro = this.responseAnalise.dadosImovelDto.livro || '' // vai ser removido
        this.dadosImovelComponente.folha = this.responseAnalise.dadosImovelDto.folha || '' // vai ser removido
        this.dadosImovelComponente.latitude = this.responseAnalise.dadosImovelDto.latitude || '' // vai ser removido
        this.dadosImovelComponente.longitude = this.responseAnalise.dadosImovelDto.longitude || '' // vai ser removido
        this.dadosImovelComponente.cartorio = this.responseAnalise.dadosImovelDto.nomeCartorio || '' // vai ser removido
        this.dadosImovelComponente.municipioCartorio = municipioCartorio?.id || '' // vai ser removido

        this.dadosImovelComponente.povoado = this.responseAnalise.dadosImovelDto.bairroPovoado || ''
        this.dadosImovelComponente.municipio = municipioImovel?.id || ''
        this.dadosImovelComponente.numeroDeControle = this.responseAnalise.dadosImovelDto.numeroDeControle || ''
        this.dadosImovelComponente.quadraDeControle = this.responseAnalise.dadosImovelDto.quadraDeControle || ''
        this.dadosImovelComponente.logradouro = this.responseAnalise.dadosImovelDto.logradouro || ''
        this.dadosImovelComponente.areaOrigin = this.responseAnalise.dadosImovelDto.areaOrigin || 0
        this.dadosImovelComponente.tipoArea = this.responseAnalise.dadosImovelDto.tipoArea || ''
      }
    },

    async montarTela () {
      if (!this.isReurb && this.responseAnalise.redirecionarModuloGeoAutomatico) {
        this.isUltimoPasso = this.responseAnalise.analiseGeoAutmaticaFinalizada
        this.showButtonProximo = !this.responseAnalise.analiseGeoAutmaticaFinalizada
      }

      let acaoSelecionada = null
      let usuarioEncaminhar = null
      if (this.dadosCadastros?.despacho?.processo?.usuarioEncaminhar) {
        usuarioEncaminhar = _.cloneDeep(
          this.dadosCadastros.despacho.processo.usuarioEncaminhar
        )
      }
      if (this.dadosCadastros && this.dadosCadastros.despacho.acao) {
        acaoSelecionada = this.dadosCadastros.despacho.acao
      } else {
        acaoSelecionada = this.responseAnalise.despacho.acao
      }
      this.radios = await this.tarefa({ processo: this.idProcesso })

      if (this.processo.setor === 'DJ' &&
          (this.processo.tipo.codigo !== 'NAO_ONEROSO' &&
          this.processo.tipo.codigo !== 'ONEROSO')) {
        this.radios.acoes = this.radios.acoes.filter(acao => acao.nome !== 'Deferimento automático')
      }

      try {
        this.numeroProcesso = this.processo.numeroProcesso
        this.acoesRadio = this.radios.acoes
        // if (process.env.ESTADO === 'ma') {
        //   this.reformulaNomesEncaminhamentos()
        // }
        this.djAnaliseConjunta = !!this.acoesRadio.find(a => a.valor?.includes('CONJUNTA'))
        if (this.djAnaliseConjunta) {
          this.isDecisao = this.djAnaliseConjunta
        }
        this.anexos = this.responseAnalise.despacho.anexos
        this.dadosCadastros = this.responseAnalise
        this.dadosCadastros.despacho.documentos = []
        if (usuarioEncaminhar !== null) {
          this.dadosCadastros.despacho.processo.usuarioEncaminhar = usuarioEncaminhar
        }
        this.anexoPublicacao =
          this.responseAnalise.despacho.anexosPublicacao &&
          this.responseAnalise.despacho.anexosPublicacao.length > 0
            ? this.responseAnalise.despacho.anexosPublicacao[0]
            : null
        this.dadosCadastros.despacho.tarefaId = this.radios.id
        this.dataPublicacao = typeof this.responseAnalise.despacho.dataPublicacao === 'number' ? this.formatDate(this.responseAnalise.despacho.dataPublicacao) : this.responseAnalise.despacho.dataPublicacao
        this.anexoPublicacao = this.responseAnalise.despacho.documentoPublicacao
        this.groupAnaliseAutomatizada = this.responseAnalise.isAnaliseAutomatizada
        this.mapas = this.responseAnalise?.despacho?.anexosMapa
          ? this.responseAnalise.despacho.anexosMapa
          : []
        this.cartas = this.responseAnalise?.despacho?.anexosCarta
          ? this.responseAnalise.despacho.anexosCarta
          : []
        this.laudo = this.responseAnalise?.despacho?.anexosLaudo
          ? this.responseAnalise.despacho.anexosLaudo
          : []
        this.termoRecebimento = this.responseAnalise?.despacho?.termoRecebimento
          ? this.responseAnalise.despacho.termoRecebimento
          : []
        this.numeroDoe = this.responseAnalise.despacho.numeroDoe
        this.dataDespachos = this.responseAnalise.setores
        this.dadosCadastros.despacho.acao = acaoSelecionada
        this.isRealizarGeorreferenciamento = this.dadosCadastros.despacho.isRealizarGeorreferenciamento
        if (this.regras.decisoes) {
          this.decisao = this.regras.decisoes
        }
        if (this.isVistoria()) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoVistoria',
            titulo: 'Vistoria',
            documentos: this.anexosVistoriador,
            tiposDocumentos: this.getTiposDocumentosVistoria().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosVistoria()
              .obrigatorios,
            aba: 'Vistoria'
          }

          await this.responseAnalise.despacho.anexosVistoriador.map(
            documento => {
              this.anexosVistoriador.push(this.formataDocumento(documento))
            }
          )
        } else if (this.isPortaria()) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoPortaria',
            titulo: 'Portaria',
            documentos: this.anexosPortaria,
            tiposDocumentos: this.getTiposDocumentosPortaria().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosPortaria()
              .obrigatorios,
            aba: 'Portaria'
          }

          await this.responseAnalise.despacho.anexosPublicacao.map(
            documento => {
              this.anexosPortaria.push(this.formataDocumento(documento))
            }
          )
        } else if (this.isDocumentoReurb()) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoReurb',
            titulo: 'Documento',
            documentos: this.anexosDocumentoReurb,
            tiposDocumentos: this.getTiposDocumentosReurb().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosReurb()
              .obrigatorios,
            aba: 'Documento'
          }
          await this.responseAnalise.despacho.anexosDocumentoReurb.map(
            documento => {
              this.anexosDocumentoReurb.push(this.formataDocumento(documento))
            }
          )
        } else if (this.isDocumentoGabinete()) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentosGabinete',
            titulo: 'Documento',
            documentos: this.anexosGabineteReurbIndividual,
            tiposDocumentos: this.getTiposDocumentosGabinete().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosGabinete()
              .obrigatorios,
            aba: 'Documento'
          }
          await this.responseAnalise.despacho.anexosGabineteReurbIndividual.map(
            documento => {
              this.anexosGabineteReurbIndividual.push(this.formataDocumento(documento))
            }
          )
        }

        if (this.isMatricula()) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoPortariaMatricula',
            titulo: 'Matrícula',
            documentos: this.anexosPortariaMatricula,
            tiposDocumentos: this.getTiposDocumentosPortaria().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosPortaria()
              .obrigatorios,
            aba: 'Matrícula'
          }

          await this.responseAnalise.despacho.anexosPortariaMatricula.map(
            documento => {
              this.anexosPortariaMatricula.push(
                this.formataDocumento(documento)
              )
            }
          )
        }

        if (this.isGeoMenssura) {
          await this.responseAnalise.despacho.anexosGeomensor.map(documento => {
            this.anexosGeorreferenciamento.push(
              this.formataDocumento(documento)
            )
          })
        }

        if (this.isAnaliseSpu) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoSpu',
            titulo: 'Documentação',
            documentos: this.anexosSpu,
            tiposDocumentos: this.getTiposDocumentosSpu().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosSpu()
              .obrigatorios,
            aba: 'Documentação'
          }

          await this.responseAnalise.despacho.anexosSpu.map(documento => {
            this.anexosSpu.push(this.formataDocumento(documento))
          })
        }

        if (this.isRespostaSpu) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoSpu',
            titulo: 'Documentação',
            documentos: this.anexosRespostaSpu,
            tiposDocumentos: this.getTiposDocumentosRespostaSpu().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosRespostaSpu()
              .obrigatorios,
            aba: 'Documentação'
          }

          await this.responseAnalise.despacho.anexosSpuResposta.map(documento => {
            this.anexosRespostaSpu.push(this.formataDocumento(documento))
          })
        }

        if (this.isAnaliseArquivamento) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoArquivoPublicacao',
            titulo: process.env.ESTADO === 'ma' ? 'Cópia do Título' : 'Arquivo de publicação',
            documentos: this.anexosArquivosPublicacao,
            tiposDocumentos: this.getTiposDocumentosArquivosPublicacao().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosArquivosPublicacao()
              .obrigatorios,
            aba: process.env.ESTADO === 'ma' ? 'Cópia do Título' : 'Arquivo de publicação'
          }

          await this.responseAnalise.despacho.anexosArquivosPublicacao.map(
            documento => {
              this.anexosArquivosPublicacao.push(
                this.formataDocumento(documento)
              )
            }
          )
        }

        if (this.isAnaliseRelatorio) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoRelatorio',
            titulo: 'Relatório',
            documentos: this.anexosRelatorio,
            tiposDocumentos: this.getTiposDocumentosRelatorio().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosRelatorio()
              .obrigatorios,
            aba: 'Relatório'
          }

          await this.responseAnalise.despacho.anexosRelatorio.map(documento => {
            this.anexosRelatorio.push(this.formataDocumento(documento))
          })
        }

        if (this.isPublicacaoEdital) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoPublicacaoEdital',
            titulo: 'Publicação Edital',
            documentos: this.anexosPublicacaoEdital,
            tiposDocumentos: this.getTiposDocumentosPublicacaoEdital().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosPublicacaoEdital()
              .obrigatorios,
            aba: 'Publicação Edital'
          }

          await this.responseAnalise.despacho.anexosPublicacaoEdital.map(
            documento => {
              this.anexosPublicacaoEdital.push(this.formataDocumento(documento))
            }
          )
        }

        if (this.isAguardandoEdital) {
          await this.responseAnalise.despacho.anexosPublicacao.map(
            documento => {
              this.anexosPublicacaoEdital.push(documento)
            }
          )
        }

        if (this.isAnalisePge) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoPGE',
            titulo: 'Parecer da PGE',
            documentos: this.anexosPge,
            tiposDocumentos: this.getTiposDocumentosPge().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosPge()
              .obrigatorios,
            aba: 'Parecer da PGE'
          }

          await this.responseAnalise.despacho.anexosPge.map(documento => {
            this.anexosPge.push(this.formataDocumento(documento))
          })
        }

        if (this.isAnaliseCasaCivil) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoCasaCivil',
            titulo: 'Decreto',
            documentos: this.anexosDecreto,
            tiposDocumentos: this.getTiposDocumentosDecreto().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosDecreto()
              .obrigatorios,
            aba: 'Decreto'
          }

          await this.responseAnalise.despacho.anexosDecreto.map(documento => {
            this.anexosDecreto.push(this.formataDocumento(documento))
          })
        }

        if (this.isDecisaoFinal) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoDecisaoFinal',
            titulo: 'Decisão Final',
            documentos: this.anexosDecisaoFinal,
            tiposDocumentos: this.getTiposDocumentosDecisaoFinal().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosDecisaoFinal()
              .obrigatorios,
            aba: 'Decisão Final'
          }

          await this.responseAnalise.despacho.anexosDecisaoFinal.map(
            documento => {
              this.anexosDecisaoFinal.push(this.formataDocumento(documento))
            }
          )
        }

        if (this.isAnalisePds) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoPds',
            titulo: 'Plano de desenvolvimento social',
            documentos: this.anexosPds,
            tiposDocumentos: this.getTiposDocumentosPds().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosPds()
              .obrigatorios,
            aba: 'Plano de desenvolvimento social'
          }

          await this.responseAnalise.despacho.anexosPds.map(documento => {
            this.anexosPds.push(this.formataDocumento(documento))
          })
        }

        if (this.isAnaliseIncra) {
          this.hasAnexoDocumento = true
          this.componenteAnexoDocumento = {
            idUploadDocumento: 'documentoIncra',
            titulo: 'Portaria de reconhecimento INCRA',
            documentos: this.anexosIncra,
            tiposDocumentos: this.getTiposDocumentosIncra().tipos,
            tiposDocumentosObrigatorios: this.getTiposDocumentosIncra()
              .obrigatorios,
            aba: 'Portaria de reconhecimento INCRA'
          }

          await this.responseAnalise.despacho.anexosIncra.map(documento => {
            this.anexosIncra.push(this.formataDocumento(documento))
          })
        }
        if (!this.showButtonsTramitacao) {
          this.dadosCadastros.despacho.acao = this.acoesRadio[0].valor
        }
        this.setIsDecisao()

        this.adicionaDadosCamposMalha()
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message,
          8000
        )
        this.cancelar()
      }
    },
    formataDocumento (documento) {
      return {
        id: documento.id,
        fileKey: documento.key,
        fileName: documento.nome,
        caminho: documento.caminho,
        tipoDocumento: {
          codigo: documento.tipo.codigo,
          id: documento.tipo.id,
          descricao: documento.tipo.descricao
            ? documento.tipo.descricao
            : documento.tipo.codigo.replaceAll('_', ' '),
          tipo: documento.tipo.codigo
        }
      }
    },

    isValidacaoPeloMenosUmDocumento () {
      return this.isVistoria() && this.componenteAnexoDocumento.tiposDocumentos.length > 0 &&
        this.componenteAnexoDocumento.tiposDocumentosObrigatorios.length === 0
    },

    async changeTipoAnalise () {
      await axios({
        method: 'PUT',
        url: `despacho/changedTipoAnalise/${this.dadosCadastros.despacho.id}`
      })
      this.dadosCadastros.despacho.flagAnaliseAutomatizada = !this
        .dadosCadastros.despacho.flagAnaliseAutomatizada
      this.dadosCadastros.despacho.analiseAutomatizada = null
      this.dadosCadastros.despacho.textoDespacho = ''
      this.dadosCadastros.despacho.documentos = []
      this.groupAnaliseAutomatizada = false
      if (this.isReurb) {
        this.hasAnexoLaudo = true
      } else {
        this.mapas = []
      }
    },

    async changeAnalise (noConfirmation = false) {
      if (noConfirmation) {
        await this.changeTipoAnalise()
        return
      }

      this.confirmBox(
        'Tem certeza que deseja alterar o tipo de análise? Os dados preenchidos serão perdidos.',
        this.$messages.TITULO_WARNING,
        async () => {
          await this.changeTipoAnalise()
        },
        () => {}
      )
    },

    async salvarAutomatizada ({ dadosAnalise }) {
      this.dadosCadastros.despacho.analiseAutomatizada = dadosAnalise
      await this.salvar()
    },

    finalizarAutomatizada (dadosAnalise) {
      this.dadosCadastros.despacho.analiseAutomatizada = dadosAnalise
      this.finalizar()
    },

    isVistoria () {
      return this.dadosCadastros.showAdicionarDocumentosVistoria
    },

    isDocumentoReurb () {
      return this.dadosCadastros.showAdicionarDocumentosReurb
    },

    isDocumentoGabinete () {
      return this.dadosCadastros.showAdicionarDocumentosGabinete
    },

    isPortaria () {
      return this.dadosCadastros.showAdicionarDocumentoPortaria
    },

    isMatricula () {
      return this.dadosCadastros.showAdicionarDocumentoPortariaMatricula
    },

    getTiposDocumentosVistoria () {
      return tiposDocumentosVistoria
    },
    getTiposDocumentosReurb () {
      return tiposDocumentosRurb
    },
    getTiposDocumentosGabinete () {
      return tiposDocumentosGabinete
    },
    getTiposDocumentosSpu () {
      return tiposDocumentosSpu
    },

    getTiposDocumentosRespostaSpu () {
      return tiposDocumentosSpuResposta
    },

    getTiposDocumentosArquivosPublicacao () {
      return tiposDocumentosArquivosPublicacao
    },

    getTiposDocumentosRelatorio () {
      return tiposDocumentosRelatorio
    },

    getTiposDocumentosPortaria () {
      return tiposDocumentosPortaria
    },

    getTiposDocumentosPublicacaoEdital () {
      return tiposDocumentosPublicacaoEdital
    },

    getTiposDocumentosPge () {
      return tiposDocumentosPge
    },

    getTiposDocumentosDecreto () {
      return tiposDocumentosDecreto
    },

    getTiposDocumentosDecisaoFinal () {
      return tiposDocumentosDecisaoFinal
    },

    getTiposDocumentosPds () {
      return tiposDocumentosPds
    },

    getTiposDocumentosIncra () {
      return tiposDocumentosIncra
    },

    setActivePai (valor) {
      this.$emit('setActive', valor)
    },

    buscarDocumentoTermo (documentos) {
      const tipoDocumento = this.uploadDoTermoOuContrato
        ? this.documentoTermoOuContrato
        : this.documentoTermoRecebimento
      return documentos.filter(
        documento => documento.tipo.id === tipoDocumento.id
      )
    },

    async updateBeneficiarios () {
      const processo = await this.getProcesso(this.processo.numeroProtocolo)
      this.dadosCadastro.dadosCadastro.dados.cadastro.beneficiarios = processo.dadosCadastro.dados.cadastro.beneficiarios
    },

    voltar () {
      this.$router.back()
    },

    receiveDataFromChild (data) {
      this.dadosCadastros.despacho.municipios = data
    }
  },

  watch: {
    isDecisao: {
      async handler (val) {
        if (!this.showButtonsTramitacao) {
          this.dadosCadastros.despacho.acao = val
            ? this.acoesRadio[1].valor
            : this.acoesRadio[0].valor
        }
      }
    },
    'dadosCadastros.despacho.acao' (newValue) {
      this.isSelectedRetornarEmissaoReurb = isCheckedRetornarEmissaoReurb(newValue)
    }
  }
}
</script>
<style lang="scss">

.el-collapse-item__header {
  color: rgb(112, 112, 112);
  font-size: 16px;
}

.padding {
  padding: 5px;
}

.required {
  color: firebrick;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.container-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label {
  font-weight: bold;
}

.radios-despacho-parecer {
  display: flex;
  justify-content: center;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.extra-margin-top-bottom {
  margin-top: 30px;
  margin-bottom: 30px;
}

.margin-medium-top {
  margin-top: 20px;
}

.campo {
  margin-top: 2%;
}

.top-georreferenciamento {
  margin-top: 30px;
  text-align: center;
}

.button {
  border: none;
  background: none;
  padding: 0;
}

.button-modal-label {
  font-weight: bold;
  color: #009c66 !important;
}

.button-comIcone span {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.marginBotton {
  margin-bottom: 20px;
}

.full-width {
  width: 100%;
}

.download-button {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}

@media (max-width: 780px) {
  .buttonValidarProcesso {
    flex-direction: column;
  }

  .btn {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/AnalisarValidarProcesso.vue